import { defineMessages } from "react-intl";

export const messages = defineMessages({
  invalidatedEntities: {
    id: "invalidated_entities",
    defaultMessage: "Zneplatněné entity"
  },
})
